import { logger } from '@user-portal/logger';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from 'store/configureStore';

import Sentry from 'services/Sentry/SentryInstance';

import App from './App';
import { isProd } from './helpers/utils';
import reportWebVitals from './reportWebVitals';
import { initDatadogRUM } from './services/Datadog/initDatadogRUM';
import { initLogger } from './services/Datadog/initLogger';
import { initOneTrust } from './services/OneTrust/initOneTrust';

Sentry.init();

isProd() && initOneTrust();

initLogger();
initDatadogRUM();

const rootDiv = document.getElementById('root');

if (rootDiv) {
    const root = createRoot(rootDiv);

    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );
}

reportWebVitals((metric) => {
    logger.info('Web Vitals', {
        name: metric.name,
        value: metric.value,
    });
});
